// m端图片详情页2s自动显示询价弹窗 & 离开时强制弹出询价弹窗
import React, {
  useState,
  useEffect,
  useCallback,
  useImperativeHandle,
  forwardRef,
} from "react";
import { TestDriveModal } from "newcar-ui/output/cjs/components/AskpricePublicModal";
import {
  setCookie,
  getCookie,
  live,
} from "newcar-ui/output/cjs/utils/tools";
import { sendClickStatistics_wmda } from "newcar-ui/output/cjs/utils/wmdaTracklog";
import { request } from "newcar-ui/output/cjs/utils/request";
// import Bus from "../eventBus";
import "./style.scss";
let timer = null;
let AskpricePop = forwardRef((props, ref) => {
  const { productId, lineId, cityId } = props;
  useImperativeHandle(
    ref,
    () => {
      return {
        showBottomPop: () => {
          // 显示底部弹窗
          if (!getCookie(`picAskpricePopFormBottom_${lineId}`)) {
            timer = setTimeout(() => {
              // 页面已经显示弹窗时不再显示自动弹窗
              const modelDoms = document.querySelectorAll(".xinche-modal");
              const hasOpen = [...modelDoms].some(
                (dom) => !dom.classList.contains("hide")// eslint-disable-line
              ); 
              const hasSideOpen =
                document.querySelectorAll(".moveLeft").length > 0;
              !hasOpen && !hasSideOpen && getCarInfo();
            }, 2000);
          }
        },
      };
    },
    [props]
  );
  const [askpricePopFromBottomShow, setAskpricePopFromBottomShow] =
    useState(false);
  const [askpricePopFromBottomTitleInfo, setAskpricePopFromBottomTitleInfo] =
    useState({});
  const getCarInfo = useCallback(() => {
    if (Object.keys(askpricePopFromBottomTitleInfo).length != 0) {
      // 已经有车型相关信息
      setAskpricePopFromBottomShow(true);
      return;
    }
    // 获取车型信息
    request(
      "//service.58che.com/unify/v1/popup/",
      {
        _type: "mPicDetailPopup",
        lineId: lineId,
        productId: productId,
        cityId: cityId,
      },
      "jsonp"
    )
      .then((resp) => {
        if (resp.code == 0) {
          const {
            productId: proId = "",
            title = "",
            subTitle = "",
            btnTitle = "",
          } = resp.entity.data || {};
          setAskpricePopFromBottomTitleInfo({
            proId,
            proName: title,
            subTitle,
            btnStr: btnTitle,
          });
          timer && setAskpricePopFromBottomShow(true);
        } else {
          throw resp;
        }
      })
      .catch((error) => {
        console.log(error.message || error.msg || error);
      });
  }, [props, askpricePopFromBottomTitleInfo]);
  useEffect(() => {
    // Bus.addListener("hideAskpricePopFromBottom", (hideFlag) => {
    //   if (hideFlag) {
    //     console.log("隐藏此弹窗");
    //     clearTimeout(timer);
    //     timer = null;
    //     setAskpricePopFromBottomShow(false);
    //   }
    // });
    // 切换车型和颜色按钮点击时 底弹窗隐藏
    const btnWrap = document.querySelector(".changeBox");
    if (btnWrap) {
      live(btnWrap, "a", "touchstart", () => {
        setAskpricePopFromBottomShow(false);
      });
    }
  }, []);
  useEffect(() => {
    if (askpricePopFromBottomShow) {
      // 底部弹起弹窗曝光埋点
      sendClickStatistics_wmda(290, {
        pagetype: "prd",
        page: "line-pic-view",
        platform: "m",
        cate_lv1: "prd",
        cate_lv2: "line",
        cate_lv3: "pic-detail",
      });
    }
  }, [askpricePopFromBottomShow]);
  const onCloseAskpricePopFromBottom = useCallback(() => {
    // 关闭底部弹起弹窗
    sendClickStatistics_wmda(291, {
      pagetype: "prd",
      page: "line-pic-view",
      platform: "m",
      cate_lv1: "prd",
      cate_lv2: "line",
      cate_lv3: "pic-detail",
    });
    setAskpricePopFromBottomShow(false);
  }, []);
  const onSubmitAskpricePopFromBottom = useCallback(() => {
    // 询价成功
    setCookie({
      name: `picAskpricePopFormBottom_${lineId}`,
      value: 1,
      expiredays: 1,
    });
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      setAskpricePopFromBottomShow(false);
    }, 2000);
    return Promise.reject("提交成功，稍后4S店顾问和您联系");
  }, []);

  return (
    <>
      <TestDriveModal
        modalCn="askpricePopFromBottomCon"
        visible={askpricePopFromBottomShow}
        closeFun={onCloseAskpricePopFromBottom}
        fCode={1235}
        bannedDisplayModule={["name"]}
        allowMaskClose={true}
        titleRelate={{
          mainTitle:
            (askpricePopFromBottomTitleInfo &&
              typeof askpricePopFromBottomTitleInfo.proName != "undefined" &&
              askpricePopFromBottomTitleInfo.proName) ||
            "",
          btnSubTitle:
            (askpricePopFromBottomTitleInfo &&
              typeof askpricePopFromBottomTitleInfo.btnStr != "undefined" &&
              askpricePopFromBottomTitleInfo.btnStr) ||
            "",
          btnMainTitle: " ",
        }}
        topSlotNode={
          <div className="askpricePopFromBottomSubTitle">
            {(askpricePopFromBottomTitleInfo &&
              typeof askpricePopFromBottomTitleInfo.subTitle != "undefined" &&
              askpricePopFromBottomTitleInfo.subTitle) ||
              ""}
          </div>
        }
        prodInfoRelate={{
          productId: askpricePopFromBottomTitleInfo.proId || productId,
          lineId: lineId,
        }}
        submitRelate={{
          onSubmitSuccessFn: onSubmitAskpricePopFromBottom,
        }}
        messageCodeRelate={{
          needMsgCode: 0,
        }}
      />
    </>
  );
});
AskpricePop.defaultProps = {
  productId: "",
  lineId: "",
  cityId: "",
};
export default AskpricePop;
